module.exports = __webpack_public_path__ + "img/triangle_phone-bottom.dcd0e823.png";